import React from 'react';
import { RouterProvider } from 'react-router';
import NavBar from '../components/NavBar/NavBar';
import DevControls from '../components/Dev/DevControls';

import '../styles/main.scss';


const SignUpMain = ({router}: {router:any}) => {

    return (
        <main id={`app-container`}> 
            <NavBar />
              
            <RouterProvider
                router={router}
            />
            
            {globalThis.localStorage.getItem('isLocalDev') === 'true' && 
                <DevControls /> 
            }
        </main>
    );
}

export default SignUpMain